import { GameVars } from "./GameVars";

import { GameManager } from "./GameManager";

// ?mv_cas_oauth_token=H62geje793gd32b&property=PP_PAYTM
// https://www.footchinko.com/games/gamepind-go-chicken-go/?mv_cas_oauth_token=H62geje793gd32b&property=PP_PAYTM


    export class ConnectionManager {

        private static game: Phaser.Game;

        private static connection: WebSocket;
        private static params: any;

        public static init(game: Phaser.Game): void {

            ConnectionManager.game = game;

            ConnectionManager.params = ConnectionManager.getAllUrlParams(window.location.search.slice(1));

            if (!ConnectionManager.params.property) {
                ConnectionManager.params.property = "PP_WEB";
            }

            console.log(ConnectionManager.params);

            ConnectionManager.createConnection();
        }

        public static createConnection(): void {

            // const endpoint = (window.location.hostname.indexOf("localhost") !== -1)
            //     ? "ws://localhost:2567" // development (local)
            //     : "wss://" + window.location.hostname + "/gamepind-go-chicken-go";

            const endpoint = "ws://gochicken.gamepind.com";

            ConnectionManager.connection = new WebSocket(endpoint);

            ConnectionManager.connection.onopen = () => {

                console.log(ConnectionManager.params);

                let message;

                if (ConnectionManager.params.mv_cas_oauth_token && ConnectionManager.params.property) {

                    message = {type: "get_user_data", data: {property: ConnectionManager.params.property, deviceID: "99fa3a558416e5f1", access_token: ConnectionManager.params.mv_cas_oauth_token}};                   
                } else if (ConnectionManager.params.access_token) {
                    message = {type: "get_user_data", data: {property: ConnectionManager.params.property, deviceID: "99fa3a558416e5f1", access_token: ConnectionManager.params.access_token}};
                } else {
                    message = {type: "o_auth_sign_up", data: {deviceID: "99fa3a558416e5f1"}};
                    console.log("FALTAN PARAMETROS");
                }

                ConnectionManager.connection.send(JSON.stringify(message));

                setTimeout(ConnectionManager.ping, 1000);
                
                // GameManager.init(this.game);
            };

            ConnectionManager.connection.onerror = error => {
                console.log("WebSocket error: ${error}");
            };

            ConnectionManager.connection.onmessage = e => {
                console.log("DATA RECEIVED");

                let data = JSON.parse(e.data);

                if (data.type === "userData") {
                    GameVars.gamepindUser = data.data;
                    console.log(GameVars.gamepindUser);
                    GameManager.init(this.game);
                } else if (data.type === "oAuthSignUp") {
                    window.open(data.data, "_self");
                } else if (data.type === "pong") {
                    console.log("PONG");
                }
            };

            ConnectionManager.connection.onclose = () => {
                console.log("WEBSOCKET CLOSED");
            }
        }

        public static ping(): void {

            let pingMessage = {type: "ping"};
            ConnectionManager.connection.send(JSON.stringify(pingMessage));
            setTimeout(ConnectionManager.ping, 10000);
        }

        public static sendHighscore(): void {

            const id = GameVars.gamepindUser.mobile_number + "";

            let time = Math.round((this.game.time.now - GameVars.time) / 1000);

            var hours   = Math.floor(time / 3600);
            var minutes = Math.floor((time - (hours * 3600)) / 60);
            var seconds = time - (hours * 3600) - (minutes * 60);

            let textHours = "" + hours;
            let textMinutes = "" + minutes;
            let textSeconds = "" + seconds;

            if (hours < 10) {
                textHours = "0" + textHours;
            }
            if (minutes < 10) {
                textMinutes = "0" + textMinutes;
            }
            if (seconds < 10) {
                textSeconds = "0" + textSeconds;
            }

            let textTime = textHours + ":" + textMinutes + ":" + textSeconds;

            const message = {type: "highscore", data: {id: id , highscore: btoa(GameVars.score + ""), time: textTime, params: ConnectionManager.params}};

            console.log(message);

            ConnectionManager.connection.send(JSON.stringify(message));
        }

        public static getAllUrlParams(url: string): any {

            var queryString = url;

            var obj: any = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split("#")[0];

                // split our query string into its component parts
                var arr = queryString.split("&");

                for (var i = 0; i < arr.length; i++) {
                    // separate the keys and the values
                    var a = arr[i].split("=");

                    // set parameter name and value (use 'true' if empty)
                    var paramName = a[0];
                    var paramValue = typeof (a[1]) === "undefined" ? true : a[1];

                    // (optional) keep case consistent
                    // paramName = paramName.toLowerCase();
                    // if (typeof paramValue === "string") { paramValue = paramValue.toLowerCase(); }

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        var key = paramName.replace(/\[(\d+)?\]/, "");
                        if (!obj[key]) { obj[key] = []; }

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                        // get the index value and add the entry at the appropriate position
                        var index = /\[(\d+)\]/.exec(paramName)[1];
                        obj[key][index] = paramValue;
                        } else {
                        // otherwise add the value to the end of the array
                        obj[key].push(paramValue);
                        }
                    } else {
                        // we're dealing with a string
                        if (!obj[paramName]) {
                            // if it doesn't exist, create property
                            obj[paramName] = paramValue;
                        } else if (obj[paramName] && typeof obj[paramName] === "string") {
                            // if property does exist and it's a string, convert it to an array
                            obj[paramName] = [obj[paramName]];
                            obj[paramName].push(paramValue);
                        } else {
                            // otherwise add the property
                            obj[paramName].push(paramValue);
                        }
                    }
                }
            }
            return obj;
        }
    }
